import { useStatsigClient } from '@statsig/react-bindings'

import { STATSIG_EXPERIMENTS } from '../../config/statsig-experiments.config'

import { useStatsigInitContext } from './statsig.context'

/**
 *
 * @param experimentKey
 * @deprecated use useStatsigExperiment instead
 */
export function useStatsigExperimentBucket(experimentKey: STATSIG_EXPERIMENTS | null) {
  const { getExperimentBucket } = useStatsigInitContext()

  if (!experimentKey) return null

  const experimentBucket = getExperimentBucket(experimentKey)
  return experimentBucket
}

export function useStatsigExperiment(
  experimentKey: STATSIG_EXPERIMENTS | null,
  shouldFetchExperiment = true,
  paramKeys: string[] = [],
) {
  const { getExperimentBucket, init } = useStatsigInitContext()
  const { getExperiment } = useStatsigClient()

  if (!experimentKey || !shouldFetchExperiment) {
    return { experimentBucket: null, init, params: {} as Record<string, unknown> }
  }

  const experimentBucket = getExperimentBucket(experimentKey)

  const params: Record<string, unknown> = {}
  if (paramKeys.length > 0) {
    const experimentConfig = getExperiment(experimentKey, { disableExposureLog: true })
    for (const key of paramKeys) {
      params[key] = experimentConfig.get(key, null)
    }
  }

  return { experimentBucket, init, params }
}
